import { Injectable, inject } from '@angular/core'
import { catchError, map, throwError, Observable } from 'rxjs'
import {
  BeginPasskeyRegistrationGQL,
  BeginPasskeyRegistrationMutation,
  FinishPasskeyRegistrationGQL,
  FinishPasskeyRegistrationMutation,
  BeginPasskeyAuthenticationGQL,
  BeginPasskeyAuthenticationMutation,
  FinishPasskeyAuthenticationGQL,
  FinishPasskeyAuthenticationMutation,
  DeletePasskeyGQL,
  DeletePasskeyMutation,
} from '../../../_generated/graphql'
import {
  throwIfCustomError,
  ALL_CUSTOM_ERROR_CODES,
} from '../../util/throwIfCustomError'

@Injectable({ providedIn: 'root' })
export class PasskeyService {
  private beginPasskeyRegistrationGQL = inject(BeginPasskeyRegistrationGQL)
  private finishPasskeyRegistrationGQL = inject(FinishPasskeyRegistrationGQL)
  private beginPasskeyAuthenticationGQL = inject(BeginPasskeyAuthenticationGQL)
  private finishPasskeyAuthenticationGQL = inject(
    FinishPasskeyAuthenticationGQL,
  )
  private deletePasskeyGQL = inject(DeletePasskeyGQL)
  beginRegistration(): Observable<
    BeginPasskeyRegistrationMutation['beginPasskeyRegistration']
  > {
    return this.beginPasskeyRegistrationGQL.mutate({}).pipe(
      map((result) => {
        if (!result.data) throw new Error('Missing passkey response')
        return result.data.beginPasskeyRegistration
      }),
      catchError((error: unknown) => {
        throwIfCustomError(error, ALL_CUSTOM_ERROR_CODES)
        return throwError(() => error)
      }),
    )
  }
  finishRegistration(
    challengeId: string,
    response: string,
    displayName: string,
  ): Observable<
    FinishPasskeyRegistrationMutation['finishPasskeyRegistration']
  > {
    return this.finishPasskeyRegistrationGQL
      .mutate({ variables: { challengeId, response, displayName } })
      .pipe(
        map((result) => {
          if (!result.data) throw new Error('Missing passkey response')
          return result.data.finishPasskeyRegistration
        }),
        catchError((error: unknown) => {
          throwIfCustomError(error, ALL_CUSTOM_ERROR_CODES)
          return throwError(() => error)
        }),
      )
  }
  beginAuthentication(): Observable<
    BeginPasskeyAuthenticationMutation['beginPasskeyAuthentication']
  > {
    return this.beginPasskeyAuthenticationGQL.mutate({}).pipe(
      map((result) => {
        if (!result.data) throw new Error('Missing passkey response')
        return result.data.beginPasskeyAuthentication
      }),
      catchError((error: unknown) => {
        throwIfCustomError(error, ALL_CUSTOM_ERROR_CODES)
        return throwError(() => error)
      }),
    )
  }
  finishAuthentication(
    challengeId: string,
    response: string,
  ): Observable<
    FinishPasskeyAuthenticationMutation['finishPasskeyAuthentication']
  > {
    return this.finishPasskeyAuthenticationGQL
      .mutate({ variables: { challengeId, response } })
      .pipe(
        map((result) => {
          if (!result.data) throw new Error('Missing passkey response')
          return result.data.finishPasskeyAuthentication
        }),
        catchError((error: unknown) => {
          throwIfCustomError(error, ALL_CUSTOM_ERROR_CODES)
          return throwError(() => error)
        }),
      )
  }
  deletePasskey(
    id: string,
  ): Observable<DeletePasskeyMutation['deletePasskey']> {
    return this.deletePasskeyGQL.mutate({ variables: { id } }).pipe(
      map((result) => {
        if (!result.data) throw new Error('Missing passkey response')
        return result.data.deletePasskey
      }),
      catchError((error: unknown) => {
        throwIfCustomError(error, ALL_CUSTOM_ERROR_CODES)
        return throwError(() => error)
      }),
    )
  }
}
